import React, { Component } from 'react'
import { CLOUDS, SILVER } from '../utils/colors'


class Title extends Component {

    static defaultProps = {
        name: 'Kyle',
        descriptors: ['software developer', '🤓', 'husband', 'software engineer', 'coffee lover ☕']
    }

    state = {
        timer: null,
        counter: 0
    }

    componentDidMount() {
        const timer = setInterval(this.tick, 3000)
        this.setState({ timer })
    }

    componentWillUnmount() {
        clearInterval(this.state.timer)
    }

    render() {
        const { length } = this.props.descriptors

        return (
            <div className='hero'>
                <div className='hero-body'>
                    <div className='container'>
                        <h1 className='title' style={{color: CLOUDS}}>
                            {`Hi, I'm ${this.props.name}!`}
                        </h1>
                        <h2 className='subtitle' style={{color: SILVER}}>
                            I{`'`}m a <b>{`${this.props.descriptors[this.state.counter % length]}`}</b>.
                        </h2>
                    </div>
                </div>
            </div>
        )
    }

    tick = () => {
        this.setState({
            counter: this.state.counter + 1
        })
    }

}


export default Title



// WEBPACK FOOTER //
// ./src/components/title.js